module.exports = __webpack_public_path__ + "img/swiper-bg2.d26ad476.png";